"use strict";
function focusNode(node) {
  try {
    node.focus();
  } catch (e) {
  }
}
module.exports = focusNode;
